/* Bloc « Ingrédients & nutrition ».
   Chaque sous-bloc « Saveur » rend sa vignette + son panneau (contrainte Horizon :
   un bloc parent ne lit pas les settings de ses enfants). Ce composant regroupe
   les vignettes en haut, n'affiche qu'un panneau à la fois, et reporte la portion
   ainsi que les intitulés des colonnes (ex. « 30 g » / « 100 g »). */
(function () {
  if (customElements.get('nutrition-facts')) return;

  function normalize(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’`]/g, "'")
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Dans l'éditeur, un sous-bloc « Ingrédient » modifié est re-rendu seul :
  // on recalcule les listes à chaque ouverture de tiroir.
  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-mpd-open]');
    if (!opener) return;
    var drawer = document.getElementById(opener.getAttribute('data-mpd-open'));
    if (!drawer) return;
    drawer.querySelectorAll('nutrition-facts').forEach(function (el) {
      if (el.fillOrigins) el.fillOrigins();
    });
  });

  customElements.define(
    'nutrition-facts',
    class NutritionFacts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.nfInit === 'true') return;
        this.dataset.nfInit = 'true';

        var tabsHost = this.querySelector('[data-nf-tabs]');
        var flavors = Array.from(this.querySelectorAll('.nf-flavor'));
        if (!tabsHost || !flavors.length) return;

        var portion = this.getAttribute('data-portion') || '';
        var col1 = this.getAttribute('data-col1') || '';
        var col2 = this.getAttribute('data-col2') || '';
        var self = this;
        this.tabs = [];
        this.panels = [];

        flavors.forEach(function (flavor, i) {
          var tab = flavor.querySelector('.nutrition-facts__tab');
          var panel = flavor.querySelector('.nutrition-facts__panel');
          if (!tab || !panel) return;

          // Portion sous le titre du tableau
          var serving = panel.querySelector('[data-nf-portion]');
          if (serving) serving.textContent = portion;

          // Intitulés des colonnes de valeurs (tableau à deux colonnes)
          panel.querySelectorAll('[data-nf-col="1"]').forEach(function (el) {
            if (col1) el.textContent = col1;
          });
          panel.querySelectorAll('[data-nf-col="2"]').forEach(function (el) {
            if (col2) el.textContent = col2;
          });

          // Déplacer la vignette dans la barre du haut
          tabsHost.appendChild(tab);
          var idx = String(i);
          tab.dataset.nfIndex = idx;
          tab.setAttribute('role', 'tab');
          panel.dataset.nfIndex = idx;

          var active = i === 0;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          panel.hidden = !active;

          tab.addEventListener('click', function () { self.select(idx); });

          self.tabs.push(tab);
          self.panels.push(panel);
        });

        this.fillOrigins();
      }

      // Photo + origine de chaque ingrédient, reprises des sous-blocs « Ingrédient »
      // du tiroir qui portent le même nom (casse et accents ignorés).
      fillOrigins() {
        var host = this.closest('.mpd__body');
        if (!host) return;
        var library = {};
        Array.from(host.children).forEach(function (item) {
          if (!item.classList.contains('mpd__origin')) return;
          var nameEl = item.querySelector('.mpd__origin-name');
          if (nameEl) library[normalize(nameEl.textContent)] = item;
        });
        this.querySelectorAll('[data-nf-ing]').forEach(function (row) {
          var item = library[normalize(row.getAttribute('data-nf-ing'))];
          var media = row.querySelector('.mpd__origin-media');
          var place = row.querySelector('.mpd__origin-place');
          var nameEl = row.querySelector('.mpd__origin-name');
          if (!item) {
            media.innerHTML = '';
            place.textContent = '';
            return;
          }
          var img = item.querySelector('img');
          media.innerHTML = img ? img.outerHTML : '';
          var srcPlace = item.querySelector('.mpd__origin-place');
          place.textContent = srcPlace ? srcPlace.textContent.trim() : '';
          var srcName = item.querySelector('.mpd__origin-name');
          if (srcName) nameEl.textContent = srcName.textContent.trim();
        });
      }

      select(index) {
        this.tabs.forEach(function (tab) {
          var active = tab.dataset.nfIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        this.panels.forEach(function (panel) {
          panel.hidden = panel.dataset.nfIndex !== index;
        });
      }
    }
  );
})();
